import React,{useState,useEffect,}from 'react'
import Main from '../cpn/Main'
import { Table,Button,Space, Radio,} from 'antd';
import { useSystemListQuery,} from '../store/ReactWebSiteApi';
import { useNavigate } from 'react-router-dom';
import AppAdd from './AppAdd';
import {appType} from './appType'
import AppEdit from './AppEdit';
import AppCheck from './AppCheck';
import AppDel from './AppDel';
import AppOnOff from './AppOnOff';
function AppIndex() {       
    const [query,setQuery] = useState()    
    const {data, isSuccess} = useSystemListQuery(query,{refetchOnMountOrArgChange:1});    
    const [list, setList] = useState();    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {esv_id:key,esv_cost_type,ent_num,esv_name,esv_num,esv_content,esv_uname,esv_ctime,esv_state,esv_image2_name,esv_image_name,esv_remark,esv_type_id,esv_price,esv_router} = item;
                    let type
                    const newArr = appType.filter(item=>item.value === esv_type_id);
                    type =  newArr[0].label
                    return item = {key,esv_cost_type,ent_num,esv_name,esv_num,esv_content,esv_uname,esv_ctime,esv_state,esv_image2_name,esv_image_name,esv_remark,type,esv_price,esv_router}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.esv_ctime;
                    let bTimeString = b.esv_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const navi = useNavigate();    
    const columns = [
        {
            key: 'list',
            title: '产品说明书',
            dataIndex: 'esv_image2_name',
            render: (text,reord) => {
                return  <AppCheck
                            src={text}
                            appName={reord.esv_name}
                            appId={reord.key}
                            brand={reord.type}
                            payType={reord.esv_cost_type}
                            esv_content={reord.esv_content}
                            esv_remark={reord.esv_remark}
                        />
            }
        },     
        {
            key: 'num',
            title: '状态',            
            dataIndex: 'esv_state',
            render:(text) => {
                if(text==='1'){
                    return<>待上架</>
                }else{
                    return<span style={{color:'red'}}>已上架</span>
                }
            }
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.esv_ctime + record.esv_uname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>                           
                        <AppEdit esv_id={record.key} />
                        {record.ent_num ==='0' && <AppDel esv_id={record.key} />}
                        <AppOnOff esv_state={record.esv_state} esv_id={record.key} />
                        <a onClick={() => {navi( `/AppSpec?esv_id=28&id=${record.key}&name=${record.esv_name}`, { state: {openKeys:'shop',active:"System"}})}}>规格</a>
                        <a onClick={() => {navi( `/AppSet?esv_id=28&id=${record.key}&name=${record.esv_name}`, { state: {openKeys:'shop',active:"System"}})}}>设置</a>
                        <a onClick={() => {navi( `/AppLimit?esv_id=28&id=${record.key}&name=${record.esv_name}`, { state: {openKeys:'shop',active:"System"}})}}>权限</a>
                        <a onClick={() => {navi( `/AppCourse?esv_id=28&id=${record.key}&name=${'【' + record.type + '】' + record.esv_name}`,)}}>教程</a>
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main t1='产品'>
            <Space size='large'>
                <Button type='primary' ><AppAdd /></Button>
                <Radio.Group
                    onChange={(e) => {
                        console.log(e.target.value);
                        setQuery(prevState=>({...prevState,esv_type_id:e.target.value}))
                    }}
                    optionType="button"
                >
                    <Radio value='1,2,3,4'>全部品牌平台</Radio>
                    <Radio value='1'>伯纳思网站</Radio>
                    <Radio value='2'>旅当家网站</Radio>
                    <Radio value='3'>导当家公众号</Radio>
                    <Radio value='4'>综点公众号</Radio>
                </Radio.Group>
                <Radio.Group
                    onChange={(e) => {
                        console.log(e.target.value);
                        setQuery(prevState=>({...prevState,esv_state:e.target.value}))
                    }}
                    optionType="button"
                >
                    <Radio value=''>全部状态</Radio>
                    <Radio value='1'>待上架</Radio>
                    <Radio value='2'>已上架</Radio>
                </Radio.Group>
            </Space> 
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />
        </Main>
    )
}

export default AppIndex